import React, { useContext } from 'react';
import icons, { buildIconUrl } from '@immediate_media/icons';
import warning from 'warning';
import { parseHtml } from '../../utils/index.js';
import ThemeContext from '../../context/ThemeContext.js';

/**
 * A hook to fetch the JSX for an icon.
 *
 * Consuming applications need to serve the icons and their sprite maps from a
 * given location and pass details of how to establish that location via the
 * ThemeContext.
 */
const useIcon = name => {
  const {
    embedIcons,
    theme,
    iconsPublicPath,
    iconsEmbedManifest
  } = useContext(ThemeContext);
  if (!(name in icons)) {
    // eslint-disable-next-line no-console
    process.env.NODE_ENV !== "production" ? warning(false, `Not a known icon: ${name}`) : void 0;
    return {};
  }
  let finalTheme = theme;
  if (!theme) {
    // eslint-disable-next-line no-console
    process.env.NODE_ENV !== "production" ? warning(false, 'No theme was provided via the `ThemeProvider`, falling back to the default.') : void 0;
    finalTheme = 'im-slate-theme';
  }
  const url = buildIconUrl(name, finalTheme, iconsPublicPath);
  const {
    aspectRatio
  } = icons[name];
  if (!embedIcons) {
    return {
      icon: /*#__PURE__*/React.createElement("use", {
        xlinkHref: url
      }),
      aspectRatio
    };
  }
  return {
    icon: parseHtml(iconsEmbedManifest[name]),
    aspectRatio
  };
};
export default useIcon;